<template>
  <el-dialog
      :visible.sync="dialogVisibility"
      width="60%"
      title="Devices found">
    <div class="modal-body">
      <el-card v-if="activeDevices.length">
        <h3 class="title">
          Active Devices
        </h3>
        <el-table
            ref="activeDevicesTable"
            :data="activeDevices">
          <el-table-column
              prop="doorbot_id"
              label="Device Id">
            <template slot-scope="scope">
              <router-link :to="{ name: 'Device', params: { customer_id: scope.row.owner_id, doorbot_id: scope.row.doorbot_id } }">
                {{ scope.row.doorbot_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
              prop="owner_id"
              label="Owner">
            <template slot-scope="scope">
              <router-link :to="{ name: 'Dashboard', params: { customer_id: scope.row.owner_id } }">
                {{ scope.row.owner_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
              prop="type"
              label="Kind">
            <template slot-scope="scope">
              {{ (product(scope.row).description || scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="name"
              label="Description" />
          <el-table-column
              prop="created_at"
              label="Created at">
            <template slot-scope="scope">
              {{ scope.row.created_at | moment('MM/DD/YYYY HH:mm') }}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card v-if="deletedDevices.length">
        <h3>Inactive Devices</h3>
        <el-table
            ref="deletedDevices"
            :data="deletedDevices">
          <el-table-column
              prop="doorbot_id"
              label="Device Id">
            <template slot-scope="scope">
              <router-link :to="{ name: 'Device', params: { customer_id: scope.row.owner_id,doorbot_id: scope.row.doorbot_id} }">
                {{ scope.row.doorbot_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
              prop="owner_id"
              label="Owner">
            <template slot-scope="scope">
              <router-link :to="{ name: 'Dashboard', params: { customer_id: scope.row.owner_id } }">
                {{ scope.row.owner_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
              prop="type"
              label="Kind">
            <template slot-scope="scope">
              {{ (product(scope.row).description || scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="name"
              label="Description" />
          <el-table-column
              prop="created_at"
              label="Created at">
            <template slot-scope="scope">
              {{ scope.row.created_at | moment('MM/DD/YYYY HH:mm') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="deleted_at"
              label="State">
            <template slot-scope="scope">
              <el-tooltip
                  :content="(scope.row.deleted_at || scope.row.deactivated_at) | moment('MM/DD/YYYY HH:mm') ">
                <span>{{ deviceState(scope.row) }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card v-if="!activeDevices.length">
        <el-alert
            :closable="false"
            type="warning"
            style="font-size: 20px">
          Click <a @click="openMissingDevice">Here</a> only if there are no active devices.
        </el-alert>
      </el-card>
    </div>
  </el-dialog>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");
import { keys, startCase } from "lodash";
import { EventBus } from "@/eventBus";

export default {
  name: "DeviceSelector",
  props: {
    profile: {
      type: Object,
      default: () => {
        return {};
      },
    },
    devices: {
      type: Array,
      required: true,
    },
    open: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      working: false,
      errors: [],
    };
  },
  computed: {
    ...sharedGetters(["products"]),
    dialogVisibility: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("update:open", value);
      },
    },
    activeDevices() {
      return this.devices.filter(
        (device) => !device.deleted_at && !device.deactivated_at
      );
    },
    deletedDevices() {
      return this.devices.filter(
        (device) => device.deleted_at || device.deactivated_at
      );
    },
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    ...sharedActions(["fetchProducts", "addProfile"]),
    closeForm() {
      this.$emit("update:open", false);
    },
    product(device) {
      return this.products.find((p) => p.kind === device.type) || {};
    },
    deviceState(device) {
      var state = "";
      if (device.deleted_at) state = "Deleted";
      else if (device.deactivated_at) state = "Deactivated";
      else state = "Active";
      return state;
    },
    openMissingDevice() {
      EventBus.$emit("device-profile-only", this.profile);
    },
  },
};
</script>
<style scoped>
h2,
h3 {
  color: #1998d5;
}
</style>
